import { StorageService } from '../../../sdk/storageService';

/**
 * ImageUploader Actions
 * Action creators ו-Thunks להעלאה ומחיקה של תמונות
 */

// ============================================
// Action Creators
// ============================================

export const uploadImageStart = () => ({
    type: 'UPLOAD_IMAGE_START'
});

export const uploadImageSuccess = (imageUrl) => ({
    type: 'UPLOAD_IMAGE_SUCCESS',
    payload: imageUrl
});

export const uploadImageFailure = (error) => ({
    type: 'UPLOAD_IMAGE_FAILURE',
    payload: error
});

export const deleteImageStart = () => ({
    type: 'DELETE_IMAGE_START'
});

export const deleteImageSuccess = () => ({
    type: 'DELETE_IMAGE_SUCCESS'
});

export const deleteImageFailure = (error) => ({
    type: 'DELETE_IMAGE_FAILURE',
    payload: error
});

// ============================================
// Thunk Actions (עם dispatch)
// ============================================

/**
 * העלאת תמונה ל-Storage עם Redux
 * @param {File} file - קובץ התמונה
 * @param {string} folder - תיקייה ב-Storage
 */
export const uploadImageWithRedux = (file, folder = 'images') => async (dispatch) => {
    dispatch(uploadImageStart());
    try {
        const imageUrl = await StorageService.uploadImage(file, folder);
        console.log('✅ תמונה הועלתה:', imageUrl);
        dispatch(uploadImageSuccess(imageUrl));
        return imageUrl;
    } catch (error) {
        console.error('❌ שגיאה בהעלאת תמונה:', error);
        dispatch(uploadImageFailure(error.message));
        throw error;
    }
};

/**
 * מחיקת תמונה מ-Storage עם Redux
 * @param {string} imageUrl - URL של התמונה למחיקה
 */
export const deleteImageWithRedux = (imageUrl) => async (dispatch) => {
    dispatch(deleteImageStart());
    try {
        await StorageService.deleteImage(imageUrl);
        console.log('✅ תמונה נמחקה:', imageUrl);
        dispatch(deleteImageSuccess());
    } catch (error) {
        console.error('❌ שגיאה במחיקת תמונה:', error);
        dispatch(deleteImageFailure(error.message));
        throw error;
    }
};

// ============================================
// Pure Functions (ללא Redux - לשימוש ב-Business components)
// ============================================

/**
 * העלאת תמונה ל-Storage (ללא Redux)
 * @param {File} file - קובץ התמונה
 * @param {string} folder - תיקייה ב-Storage
 * @returns {Promise<string>} URL של התמונה
 */
export const uploadImage = async (file, folder = 'images') => {
    try {
        const imageUrl = await StorageService.uploadImage(file, folder);
        console.log('✅ תמונה הועלתה:', imageUrl);
        return imageUrl;
    } catch (error) {
        console.error('❌ שגיאה בהעלאת תמונה:', error);
        throw new Error('שגיאה בהעלאת התמונה');
    }
};

/**
 * מחיקת תמונה מ-Storage (ללא Redux)
 * @param {string} imageUrl - URL של התמונה למחיקה
 * @returns {Promise<void>}
 */
export const deleteImage = async (imageUrl) => {
    try {
        await StorageService.deleteImage(imageUrl);
        console.log('✅ תמונה נמחקה:', imageUrl);
    } catch (error) {
        console.error('❌ שגיאה במחיקת תמונה:', error);
        throw new Error('שגיאה במחיקת התמונה');
    }
};
